import React from 'react';
import { Typography, Box, Paper } from '@mui/material';
import Layout from '../../components/Layout';

const ComercioDashboard: React.FC = () => {
  return (
    <Layout>
      <Box>
        <Typography variant="h4" gutterBottom>
          Panel de Comercio
        </Typography>
        
        <Paper sx={{ p: 3, mt: 2 }}>
          <Typography variant="h6" gutterBottom>
            Bienvenido al Panel de Comercio
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Desde aquí podrás gestionar las redenciones de cupones de tus clientes.
            Funcionalidades disponibles:
          </Typography>
          <Box component="ul" sx={{ mt: 2 }}>
            <li>Ver redenciones pendientes</li>
            <li>Aprobar o rechazar cupones</li>
            <li>Escanear códigos QR</li>
            <li>Ver estadísticas de uso</li>
            <li>Historial de transacciones</li>
          </Box>
        </Paper>
      </Box>
    </Layout>
  );
};

export default ComercioDashboard;
